// extracted by css-extract-rspack-plugin
export default {"header":"header-CbMVe6","header__booking":"header__booking-jOIvvj","headerBooking":"header__booking-jOIvvj"};